import cn from 'classnames';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { uiChangeSkladName } from '../../../../actions/ui';
import WarehouseCommonApi from '../../../../API/warehouse/common-api';
import EntriesApi from '../../../../API/warehouse/entries-api';
import { Column, ImagesViewer, NavTabs, Row, WhiteBlock } from '../../../../components/Basic/Blocks';
import { Button } from '../../../../components/Basic/Buttons';
import { Content } from '../../../../components/Basic/Global';
import { Input, Select } from '../../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../../components/Basic/Table';
import { H1, H2, Text, TextGrey } from '../../../../components/Basic/WrapsStyle';
import BarcodesBlock from '../../../../components/Common/Input/Barcodes';
import WarehouseAddressInput from '../../../../components/Warehouse/WarehouseAddressInput';
import {
  ENTRIES_STATUS,
  ENTRIES_STATUS_COLORS,
  IP_NUMBER_MAP,
  MAP_RETURNS,
  RESERVES_STATUS_COLORS,
  SKLADS_WAREHOUSE,
  TO_PRODUCT,
  TYPE_BUTTONS
} from '../../../../constans';
import { formFullDate } from '../../../../utils';
import AlertShip from './AlertShip';
import styles from './styles.module.scss';

export const width = [
  '100px', //0
  '110px', //1
  '270px', //2
  '90px', //3
  '100px', //4
  '200px', //5
  '10px', //6
  '350px', //7
  '130px', //8
];

const FILTER = {
  0: 'all',
  1: 'added',
  2: 'not_added',
};

function EntryPage() {
  const match = useParams();
  const [alert, setAlert] = useState(false);
  const [info, setInfo] = useState({});
  const [search, setSearch] = useState('');
  const dispatch = useDispatch();

  const user = useSelector(store => store.user)
  const [countStock, setCountStock] = useState([0, 0, 0]);

  const [items, setItems] = useState({ ids: [], byId: {} });
  const [returnsMap, setReturnsMap] = useState({});
  const [tab, setTab] = useState(0);

  const [warehouseMap, setWarehouseMap] = useState({});
  const [count, setCount] = useState([]);

  const params = useMemo(() => {
    console.log('tab', tab);
    return { entryIds: [match.id], search, tab: 'all', tab: FILTER[tab] };
  }, [match.id, search, tab]);

  const loadEntries = () => {
    EntriesApi.getEntriedProducts({ data: params }).then((r) => {
      const { all_count = {} } = r;

      const byIds = {};
      const id = r.products.map((item) => item._id);
      r.products.forEach((item) => (byIds[item._id] = item));

      setItems({ ids: id, byId: byIds });
      setReturnsMap(r.returnsMap);
      setWarehouseMap(r.warehouseProductsMap);
      setInfo(r.entries[0]);
      setCount(id.length);
      setCountStock([all_count.all, all_count.added, all_count.not_added]);
    });
  };

  const onConfirm = () => {
    EntriesApi.confirmEntry({ data: { entryId: info.id } }).then(() => {
      setAlert(false);
      loadEntries();
    });
  };

  const onChangeTab = (n) => {
    console.log('N', n);
    setTab(n);
  };

  const onChange = async (warehouseCard, field, value, action = null) => {
    await WarehouseCommonApi.changeProduct({ data: { warehouseId: warehouseCard.id, field, value, action, isInventory: false, skladName: info.skladName } })
      .then((p) =>
        setWarehouseMap({ ...warehouseMap, [p.warehouseProduct.id]: p.warehouseProduct }),
      );
  };

  useEffect(() => {
    loadEntries();
  }, [params]);

  useEffect(() => {
    console.log(
      info.skladName,
      SKLADS_WAREHOUSE.filter((s) => s.short_name === info.skladName),
    );
    if (info.skladName) {
      dispatch(uiChangeSkladName(SKLADS_WAREHOUSE.filter((s) => s.short_name === info.skladName)[0]));
    }
  }, [info.id]);

  return (
    <Content>
      <H1>
        Внесение № {info.id} ( {MAP_RETURNS[info.reason]} )
      </H1>

      <Row style={{ marginBottom: '10px' }}>
        <H2>Статус: </H2>{' '}
        <div className={styles.status} style={{ color: `${ENTRIES_STATUS_COLORS[info.status]}` }}>
          {`${ENTRIES_STATUS[info.status] || ''}`}
        </div>
      </Row>
      <Row style={{ marginBottom: '15px' }}>
        {(user.role === 'admin' || user.role === 'owner') && (
          <>
            <Button
              onClick={() => EntriesApi.excelEntries({
                data: {
                  entryIds: [match.id], tab: 'all'
                }
              })}
              style={{ marginRight: '10px' }}
            >
              Скачать данные excel
            </Button>
            <Button
              type={TYPE_BUTTONS.WHITE}
              onClick={() =>
                EntriesApi.reportEntries({
                  data: {
                    ...params,
                    typeFormat: 'xlsx',
                    operation_1c: 2,
                  }
                })
              }
              style={{ marginLeft: '10px', background: 'rgb(255 161 42 / 58%)' }}
            >
              Выгрузка 02B xlsx
            </Button>
            <Button
              type={TYPE_BUTTONS.WHITE}
              onClick={() =>
                EntriesApi.reportEntries({
                  data: {
                    ...params,
                    typeFormat: 'xml',
                    operation_1c: 2,
                  }
                })
              }
              style={{ marginLeft: '10px', background: 'rgb(255 161 42 / 58%)' }}
            >
              Выгрузка 02B xml
            </Button>
            <Button
              type={TYPE_BUTTONS.WHITE}
              onClick={() =>
                EntriesApi.reportEntries({
                  data: {
                    ...params,
                    typeFormat: 'xlsx',
                    operation_1c: 1,
                  }
                })
              }
              style={{ marginLeft: '10px', background: 'rgb(255 161 42 / 58%)' }}
            >
              Выгрузка 01B xlsx
            </Button>
            <Button
              type={TYPE_BUTTONS.WHITE}
              onClick={() =>
                EntriesApi.reportEntries({
                  data: {
                    ...params,
                    typeFormat: 'xml',
                    operation_1c: 1,
                  }
                })
              }
              style={{ marginLeft: '10px', background: 'rgb(255 161 42 / 58%)' }}
            >
              Выгрузка 01B xml
            </Button>
            <Button
              type={TYPE_BUTTONS.GREEN}
              style={{ marginLeft: '15px' }}
              onClick={() => EntriesApi.closeEntry({ data: { entryId: info.id } })}
              disabled={info.status === 'ended'}
            >
              Провести документы
            </Button>
          </>
        )}
      </Row>
      <Column style={{ marginBottom: '10px' }}>
        <span>
          <TextGrey className={styles.grey_text}>Дата создания: </TextGrey>
          {info.created_at ? formFullDate(info.created_at) : `-`}
        </span>
        <span>
          <TextGrey className={styles.grey_text}>Создатель: </TextGrey>
          {info.creator}
        </span>

        <Row style={{ marginTop: '10px', marginBottom: '10px' }}>
          <Button
            type={TYPE_BUTTONS.GREEN}
            style={{ marginRight: '20px' }}
            onClick={() => setAlert(true)}
            disabled={info.status === 'ended'}
          >
            Подтвердить внесение
          </Button>
        </Row>
      </Column>
      <WhiteBlock className={styles.search_block} minimize={true}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={['Все', 'Подтвержденно', 'Не подтвержденно']}
            isNum={true}
            num={countStock}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />
        </Row>

        <Input value={search} onBlur={(v) => setSearch(v)} onClickEnter={(v) => setSearch(v)} label="Поиск" />
        <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>
      </WhiteBlock>
      <Table style={{ marginTop: '20px' }} minHeight={'600px'}>
        <TableHeader whiteHeader={true}>
          <HeaderTitle width={width[6]} />
          <HeaderTitle width={width[0]} />
          <HeaderTitle width={width[8]}>Номер заказа</HeaderTitle>
          <HeaderTitle width={width[1]} centerText>
            Артикул на складе
          </HeaderTitle>
          <HeaderTitle width={width[0]} centerText>
            Адрес
          </HeaderTitle>
          <HeaderTitle width={width[7]}>Наименование</HeaderTitle>
          <HeaderTitle width={width[5]} centerText>
            Количество {info.reason === 'return' && ' / Количество ожидаемое'}
          </HeaderTitle>
          <HeaderTitle width={width[5]} centerText>Штрихкод</HeaderTitle>
          <HeaderTitle width={width[5]} centerText>
            Статус расхождения
          </HeaderTitle>
          <HeaderTitle width={width[5]} centerText>
            ИП возврата
          </HeaderTitle>
          <HeaderTitle width={width[5]} centerText>
            Закупочное Ип
          </HeaderTitle>
          <HeaderTitle width={width[8]}>Время занесения</HeaderTitle>
          <HeaderTitle width={width[9]}>Ответственный</HeaderTitle>
        </TableHeader>
        {items.ids.map((id, key) => {
          const item = items.byId[id];
          const warehouseCard = warehouseMap[item.warehouse_id] || {};
          const returnItem = (returnsMap[item.id_from] || {})?.products?.find(
            (p) => p.provider_sku === item.product.provider_sku,
          );
          return (
            <TableLine key={`${item.warehouse_id}-${key}`} styles={cn(item.is_added && styles.green_line)}>
              <TableCell width={width[6]}>{key + 1}</TableCell>
              <TableCell width={width[0]}>
                <ImagesViewer images={[warehouseCard.image]} />
              </TableCell>
              <TableCell width={width[8]}>
                <Column>
                  {item.posting?.number}
                  {item.posting?.market === 'wb' && (
                    <TextGrey style={{ fontSize: '13px', color: '#6c11c9' }}>{item.posting?.market}</TextGrey>
                  )}
                  {item.posting?.market === 'yandex' && (
                    <TextGrey style={{ fontSize: '13px', color: 'rgb(193 61 0)' }}>{item.posting?.market}</TextGrey>
                  )}
                  {item.posting?.market === 'ozon' && (
                    <TextGrey style={{ fontSize: '13px', color: 'rgb(19,79,231)' }}>{item.posting?.market}</TextGrey>
                  )}
                </Column>
              </TableCell>
              <TableCell width={width[1]} center>
                {item.warehouse_id}
              </TableCell>
              <TableCell width={width[0]} center>
                <WarehouseAddressInput
                  warehouseId={item.warehouse_id}
                  address={warehouseCard.sklad_data[info.skladName].address}
                  width={'100%'}
                //onChange={(p) => save(p)}
                />
              </TableCell>
              <TableCell width={width[7]}>
                <a href={TO_PRODUCT(item.warehouse_id)} target={'_blank'}>
                  {item.product?.name}
                </a>
              </TableCell>
              <TableCell width={width[5]} center>
                {item.product.quantity} {info.reason === 'return' && `/ ${item.product.quantity_primary}`}
              </TableCell>
              <TableCell width={width[5]} fontSize="14px">
                <BarcodesBlock
                  barcodes={warehouseCard.barcodes}
                  onAdd={(b) => onChange(warehouseCard, 'barcode', b, 'add')}
                  onRemove={(b) => onChange(warehouseCard, 'barcode', b, 'pull')}
                />
              </TableCell>
              <TableCell width={width[5]} center>
                {returnItem && (
                  <Select
                    select={returnItem.diff?.status}
                    list={['Брак', 'Пересорт', 'Просрочка', 'Подмена', 'Недовложение', 'Возврат не получили', 'Нет']}
                    style={{ fontSize: '16px' }}
                    width={'200px'}
                    disabled={returnItem.real_quantity === returnItem.common_quantity}
                    onSelect={(v) => onChange(p._id, 'diffStatus', v === 'Нет' ? null : v)}
                  />
                )}
              </TableCell>

              <TableCell width={width[5]} center>
                {info.reason !== 'overage' && <>{IP_NUMBER_MAP[item.product.ip_market_id]}</>}
              </TableCell>
              <TableCell width={width[5]} center>
                {IP_NUMBER_MAP[item.product.ip_id]}
              </TableCell>
              <TableCell width={width[8]} center>
                {formFullDate(item.scan.date)}
              </TableCell>
              <TableCell width={width[9]} center>
                {item.scan.user}
              </TableCell>
            </TableLine>
          );
        })}
      </Table>

      <Row style={{ marginBottom: '20px' }}></Row>
      {alert && <AlertShip close={() => setAlert(false)} ship={onConfirm} />}
    </Content>
  );
}

export default EntryPage;
